// extracted by mini-css-extract-plugin
module.exports = {"divLoading":"Loading_divLoading__1FNMM","btn":"Loading_btn__1G4HV"};